<template>
  <div class="p-fluid" style="">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title cs-min-page">
        <div class="manager-title-custom" style="text-align: center;">Nhập vào CCCD cần kiểm tra</div>
        <div id="check-cccd" style="text-align: center;">
          <div>
            <DropdownScrollable class="cs-csl" :loading="loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset" placeholder="Chọn công ty"/>
          </div>
          <div>
            <InputText v-model="id_card" type="text" class="cs-input-1 input-text-box" placeholder="Nhập CCCD" id="id_card"/>
            <div v-if="text_err !== ''">
              <span style="color:red;font-size: 14px;">{{text_err}}</span>
            </div>
          </div>
          <div class="cs-div-btn " style="margin-top: 10px;">
            <Button label="Kiểm tra" class="cs-btn-1" @click="checkCCCD"/>
          </div>
          <div v-if="type_view=='conhan'" class="cs-custom-cls cs-valid-permit-wrap cs-valid-permit-wrap--column">
            <div v-for="(item, index) in listGP" :key="index" class="cs-div-cus-ss">
                <div v-if="item.img_avatar" class="cs-avatar-box">
                  <img :src="item.img_avatar" alt="avatar" class="cs-avatar-img"/>
                </div>
                <div class="cs-content-box">
                <div class="cus-txt-left">
                  <span class="cs-span-txt-cls">Họ và tên:</span> <span style="text-decoration: underline;">{{item.fullname}}</span>
                </div>
                <div class="cus-txt-left">
                  <span class="cs-span-txt-cls">Tên công ty:</span> {{item.company_name}}
                </div>
                <div class="cus-txt-left">
                  <span class="cs-span-txt-cls">Nhà thầu:</span> {{item.contractor_name}}
                </div>
                <div class="cus-txt-left">
                  <span class="cs-span-txt-cls">Nhà máy:</span> {{item.factory_name}}
                </div>
                <div class="cus-txt-left">
                  <span class="cs-span-txt-cls">Công việc:</span> {{item.sra_name}}
                </div>
                <div class="cus-txt-left">
                  <span class="cs-span-txt-cls">Thời hạn:</span> <span style="color:#00A86B;font-weight: 600;">{{item.date_start}} - {{item.date_end}}</span>
                </div>
                </div>
                <div class="cs-status-check">
                  <img v-bind:src="img_check" style="width: 90px; height: 90px;"/>
                </div>
            </div>
            
          </div>
          <div v-else-if="type_view=='hethan'" class="cs-custom-cls">
            <div>
              <img v-bind:src="img_x" style="width: 90px; height: 90px;"/>
            </div>
            <div style="margin-top: 10px;">
              <span class="cs-error-text">
                {{ user_active ? 'Giấy phép này đã hết hạn sử dụng' : 'Tài khoản này không còn hoạt động' }}
              </span>
            </div>
          </div>
          <div v-else-if="type_view=='nodata'" class="cs-custom-cls">
            <div>
              <img v-bind:src="img_x" style="width: 90px; height: 90px;"/>
            </div>
            <div style="margin-top: 10px;">
              <span class="cs-error-text">
                Giấy phép ra vào cổng đã hết hạn
              </span>
            </div>
          </div>
          <div v-else-if="type_view=='nodata'" class="cs-custom-cls">
            <div>
              <img v-bind:src="img_x" style="width: 90px; height: 90px;"/>
            </div>
            <div style="margin-top: 10px;">
              <span class="cs-error-text">
                Giấy phép ra vào cổng đã hết hạn
              </span>
            </div>
          </div>
          <div v-if="type_view=='vipham'" class="cs-custom-cls cs-valid-permit-wrap">
            <div v-for="(item, index) in listGP" :key="index" class="cs-div-cus-ss-1">
                <div class="cs-div-cus-ss-2 cs-iconw-cus-text"><i class="fa fa-exclamation-triangle cs-iconw-cus" aria-hidden="true"></i><span class="cs-iconw-cus-text">Cấm vào</span></div>
                <div v-if="item.img_avatar" class="cs-avatar-box">
                  <img :src="item.img_avatar" alt="avatar" class="cs-avatar-img"/>
                </div>
                <div class="cs-content-box">
                <div class="cus-txt-left">
                  <span class="cs-span-txt-cls">Họ và tên:</span> <span style="text-decoration: underline;">{{item.fullname}}</span>
                </div>
                <div class="cus-txt-left">
                  <span class="cs-span-txt-cls">Tên công ty:</span> {{item.company_name}}
                </div>
                <div class="cus-txt-left">
                  <span class="cs-span-txt-cls">Nhà thầu:</span> {{item.contractor_name}}
                </div>
                <div class="cus-txt-left">
                  <span class="cs-span-txt-cls">Nhà máy:</span> {{item.factory_name}}
                </div>
                <div class="cus-txt-left">
                  <span class="cs-span-txt-cls">Công việc:</span> {{item.sra_name}}
                </div>
                <div class="cus-txt-left">
                  <span class="cs-span-txt-cls">Thời hạn:</span> <span style="color:red;font-weight: 600;">{{item.date_start}} - {{item.date_end}}</span>
                </div>
                </div>
                <div class="cs-violation-row">
                  <div class="cs-violation-reason">
                    <div class="cs-violation-reason__icon">
                      <i class="fa fa-exclamation-circle" style="color: red;"></i>
                    </div>
                    <div class="cs-violation-reason__content">
                      <div class="cs-violation-reason__title">LÝ DO VI PHẠM:</div>
                      <div class="cs-violation-reason__text">{{ item.violation_reason }}</div>
                    </div>
                  </div>
                  <div class="cs-error-text-1">
                    <img v-bind:src="img_x" style="width: 90px; height: 90px;"/>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiRepository from "@/core/ApiRepository";
import DropdownScrollable from '@/components/DropdownScrollable.vue';
export default {
  components: {
    DropdownScrollable
  },
  data() {
    return {
      modelName: '',
      dataModel: null,
      title: null,
      editDialogKey: 0,
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      company: {},
      company_id: null,
      filters : {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      id_card : "",
      type_view : '',//conhan/hethan/nodata
      user_active : true,
      listGP : [],
      img_check: '../../../assets/img_check.png',
      img_x: '../../../assets/img_x.png',
      text_err : '',
    }
  },
  async mounted() {
    this.company.id = this.$route.query.company_id || null;
    this.id_card = this.$route.query.id_card || '';

    if (this.company.id && this.id_card) {
      await this.checkCCCD();
    }
  },
  async created() {
    await this.getListCompany();
    this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
  },
  watch: {
    async "$store.getters.company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.$set(this,'company_id', (this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN) ? this.$store.getters?.company_id : null);
      }
    },
    async "company_id"() {
      this.company = {id: this.company_id};
    },
  },
  methods: {
    emitEvent(keyword) {
      this.$delete(this.filters, 'name');
      if (keyword) {
        this.filters.name = keyword;
      }
      this.getListCompany();
    },
    changeOffset(value) {
      this.offset = value;
      this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters}, {headers}).then((res) => {
            if (this.offset > 0) {
              this.items.push(...res.data.data.company);
            } else {
              this.items = res.data.data.company;
            }
            this.total = res.data.data.total;
            this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async checkCCCD() {
      this.text_err = '';
      this.type_view = '';
      this.listGP = []
      // console.log("this.company",this.company)
      if (this.company.id == undefined || !this.company.id) {
        alert("Vui lòng chọn công ty");
        return;
      }
      if (this.id_card == "") {
        this.text_err = 'Vui lòng nhập số CCCD';
        return;
      }else if(isNaN(this.id_card)){
        this.text_err = 'Số CCCD không hợp lệ';
        return;
      }
      this.$store.commit('setLoading', true);
      //gọi api kiểm tra
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        }
        var params = {
          id_card: this.id_card,
          company_id: this.company.id
        }
        // console.log("params===",params)
        await ApiRepository.post("/_api/company/entrance_permit", params, {headers}).then((res) => {
          var value = res.data.data;
          // console.log("value===",value)
          this.updateList(value)
        }).catch((err) => {
          if(err && err.response && err.response.data.message == 'DATA_USER_NOT_FOUND'){
            this.type_view = 'nodata';
          }else{
            return err;
          }
          this.$store.commit('setLoading', false);
        })
        
      }
    },
    updateList(value){
      // console.log("data===",value)
      var tmp = []
      var type_view = '';
      var data = value.list ?? [];
      var user = value.user ?? null;
      console.log("users==",user.list_files)
      if(user?.active === false){
        type_view = 'hethan'
      }else if(data.length > 0){
        if(user.violation_status == 'banned'){
          type_view = 'vipham'
        }else{
        type_view = 'conhan'
        }
        var fullname = '';var company_name = '';var img_avatar = '../../../assets/logo.png';
        if(user){
          fullname = user.fullname;
          if(user.company){
            company_name = user.company.name;
          }
          if(user.list_files && user.list_files.length > 0){
            img_avatar = user.list_files[0]?.file?.url ?? '../../../assets/logo.png';
          }
        }
        for (let i = 0; i < data.length; i++) {
          const e = data[i];
          var date_start = '';var date_end = '';
          date_start = this.$commonFuction.customFormatDate(e.date_start);
          date_end = this.$commonFuction.customFormatDate(e.date_end);
          var violation_reason = user?.banned_reason || 'Vi phạm an toàn lao động';
          var tp = {
            fullname: fullname,
            company_name: company_name,
            contractor_name: e.contractor_name,
            factory_name: e.factory_name,
            date_start: date_start,
            date_end: date_end,
            img_avatar: img_avatar,
            sra_name : e.sra_name,
            violation_reason: violation_reason,
          }
          tmp.push(tp);
        }
      }else{
        type_view = 'hethan'
      }
      // console.log("tmp===",tmp)
      // console.log("type_view===",type_view)
      this.type_view = type_view;
      this.user_active = user?.active !== false;
      this.listGP = tmp;
      this.$store.commit('setLoading', false);
    }
  }

}
</script>
<style lang="scss">
  .manager-title-custom{
    color: #1D3118;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
    font-weight: 700;
  }
  .cs-input-1 {
    max-width: 400px !important;
    font-size: 16px;
    height: 50px;
  }
  .cs-csl {
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .cs-div-btn {
    height: 50px;
  }
  .cs-btn-1 {
    /* width: 200px; */
    font-size: 16px;
    height: 50px;
  }
  .cs-error-text {
    color : #FF5A54;
    font-size: 14px;
    font-weight: 700;
  }
  .cs-success-text {
    color : #00A86B;
    font-size: 14px;
    font-weight: 700;
  }
  .cs-custom-cls {
    margin-top: 30px;
  }
  #check-cccd .p-button{
    width: 250px;
  }
  .cus-txt-left {
    text-align: left;
    margin-top: 2px;
  }
  .cs-span-txt-cls {
    font-weight: 700;
  }
  .cs-div-cus-ss {
    margin-top: 10px;
    width: 400px;
    border: 1px solid #0086C4;
    padding: 8px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }
  .cs-min-page {
    min-height: 85vh;
    height: auto;
  }
  .cs-valid-permit-wrap {
    display: flex;
    justify-content: center;
  }
  .cs-valid-permit-wrap--column {
    flex-direction: column;
    align-items: center;
  }
  .cs-avatar-box {
    width: 120px;
    min-width: 120px;
    border: 1px solid #0086C4;
    border-radius: 5px;
    /* padding: 6px; */
    background: #fff;
  }
  .cs-avatar-img {
    width: 120px;
    height: 120px;
    object-fit: cover;
    /* border-radius: 10px; */
    display: block;
  }
  .cs-content-box {
    flex: 1;
    min-width: 220px;
  }
  .cs-status-check {
    width: 100%;
    margin-top: 8px;
    display: flex;
    justify-content: center;
  }
  .cs-error-text-1{
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
  }
  .cs-violation-row {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    /* margin-top: 12px;
    padding-top: 12px; */
    border-top: 1px solid #e6e6e6;
  }
  .cs-violation-reason {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    min-width: 0;
  }
  .cs-violation-reason__icon {
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
  }
  .cs-violation-reason__content {
    flex: 1;
    min-width: 0;
    text-align: left;
  }
  .cs-violation-reason__title {
    color: #df1010;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 4px;
    text-transform: uppercase;
    text-align: left;
  }
  .cs-violation-reason__text {
    color: #222;
    font-size: 15px;
    line-height: 1.4;
    word-break: break-word;
    text-align: left;
  }
  .cs-div-cus-ss-1 {
    width: 400px;
    border: 1px solid #ff0505;
    padding: 8px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }
  .cs-div-cus-ss-2 {
    width: calc(100% + 16px);
    border: 1px solid #ff0505;
    background-color: red;
    box-sizing: border-box;
    margin: -8px -8px 0;
  }
  .cs-iconw-cus {
    color: white;
  }
  .cs-iconw-cus-text {
    color: white;
    font-size: 30px;
  }
  
  @media (max-width: 768px) {
    .cs-div-cus-ss {
      flex-direction: column;
      align-items: center;
    }
    .cs-content-box {
      width: 100%;
    }
    .cs-div-cus-ss-1 {
      flex-direction: column;
      align-items: center;
    }
    .cs-violation-row {
      flex-direction: column;
      align-items: center;
    }
    .cs-violation-reason {
      width: 100%;
    }
  }
  @media (max-width: 450px) {
    .cs-div-cus-ss {
      width: 100%;
    }
  }
</style>
